import React from "react";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
const ShopOrder = [
  [
    "Shop Order",
    "/admin/shop-order",
    <ShoppingBasketIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></ShoppingBasketIcon>,
  ],
];

export default ShopOrder;
